import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import sessionStorageHelper from './sessionStorageHelper.js';
import { interactionCodeFlow } from './interactionCodeFlow.js';
import { FORMS } from '../ion/RemediationConstants.js';
import transformIdxResponse from '../ion/transformIdxResponse.js';

function updateAppState(_x, _x2) {
  return _updateAppState.apply(this, arguments);
}

function _updateAppState() {
  _updateAppState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appState, idxResponse) {
    var settings, lastResponse, useInteractionCodeFlow, tokens, _idxResponse$context, ionResponse;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            settings = appState.settings;
            lastResponse = appState.get('idx');
            useInteractionCodeFlow = settings.get('oauth2Enabled');

            if (!useInteractionCodeFlow) {
              _context.next = 13;
              break;
            }

            if (!idxResponse.interactionCode) {
              _context.next = 11;
              break;
            }

            // Although session.stateHandle isn't used by interation flow,
            // it's better to clean up at the end of the flow.
            sessionStorageHelper.removeStateHandle(); // This is the end of the IDX flow, now entering OAuth

            _context.next = 8;
            return interactionCodeFlow(settings, idxResponse);

          case 8:
            tokens = _context.sent;
            // At the successful end of IDX flow `clearAppStateCache` has been called, 
            //  but `setIonResponse` is not called, so `appState` is empty.
            // In such case `FormController` is not able to render any form.
            appState.unset('currentFormName', {
              silent: true
            });
            return _context.abrupt("return", tokens);

          case 11:
            _context.next = 15;
            break;

          case 13:
            // Do not save state handle for the first page loads.
            // Because there shall be no difference between following behavior
            // 1. bootstrap widget
            //    -> save state handle to session storage
            //    -> refresh page
            //    -> introspect using sessionStorage.stateHandle
            // 2. bootstrap widget
            //    -> do not save state handle to session storage
            //    -> refresh page
            //    -> introspect using options.stateHandle
            if (lastResponse) {
              sessionStorageHelper.setStateHandle(idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.stateHandle);
            } // Login flows that mimic step up (moving forward in login pipeline) via internal api calls,
            // need to clear stored stateHandles.
            // This way the flow can maintain the latest state handle. For eg. Device probe calls


            if (appState.get('currentFormName') === FORMS.CANCEL_TRANSACTION) {
              sessionStorageHelper.removeStateHandle();
            }

          case 15:
            // transform response
            ionResponse = transformIdxResponse(settings, idxResponse, lastResponse);
            _context.next = 18;
            return appState.setIonResponse(ionResponse);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateAppState.apply(this, arguments);
}

export { updateAppState };